import React from 'react';
import { Route, Redirect, RouteProps, RouteComponentProps } from 'react-router-dom';
import Notification from '../components/Ant/Notification';

import { APICore } from '../helpers/api/apiCore';
import { isEven } from '../utils/isEven';
import PrivateRouteShareLinkComponent from './PrivateRouteShareLinkComponent';
interface PrivateRouteProps {
    component: React.FunctionComponent<RouteProps>;
    roles?: string;
    requiredScopes?: string[];
}

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRouteShareLink = ({ component: Component, roles, requiredScopes, ...rest }: PrivateRouteProps) => {
    const api = new APICore();
    return (

        <Route
            {...rest}
            render={(props: RouteComponentProps) => {
                
                return <PrivateRouteShareLinkComponent props={props} requiredScopes={requiredScopes} Component={Component} />;
            }}
        />
    );
};

export default PrivateRouteShareLink;
